export default __webpack_public_path__ + "static/media/prevActive.988ec397.svg";